import { useStorage } from '@vueuse/core'

const isFantasyGuideClosed = useStorage('is-fantasy-guide-closed', false)

export const useFantasyWelcomeGuide = () => {
  const { $dialog } = useNuxtApp()

  const openWelcomeGuide = () => {
    $dialog({
      wrapper: null,
      content: defineAsyncComponent(
        () => import('~/components/fantasy/popups/welcome-guide/index.vue')
      ),
      closeOnChangeRoute: false,
      onClose: () => {
        isFantasyGuideClosed.value = true
      }
    })
  }

  const tryOpenWelcomeGuide = () => {
    if (!isFantasyGuideClosed.value) {
      openWelcomeGuide()
    }
  }

  return {
    openWelcomeGuide,
    tryOpenWelcomeGuide
  }
}
